// extracted by mini-css-extract-plugin
module.exports = {"leftPadding":"40px","rightPadding":"40px","content":"content_content__11WUq","leftPaddedContainer":"content_leftPaddedContainer__1nkWl"};